import { render } from "./EventStages.vue?vue&type=template&id=89f69542&scoped=true"
import script from "./EventStages.vue?vue&type=script&lang=js"
export * from "./EventStages.vue?vue&type=script&lang=js"

import "./EventStages.vue?vue&type=style&index=0&id=89f69542&scoped=true&lang=css"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89f69542"]])

export default __exports__